module.exports = __webpack_public_path__ + "images/emoji/red_car.90a07a0f9db952bd9523.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/red_car.png
// module id = BZNa
// module chunks = 2